export default {
    general: {
        add:      'Dodaj',
        edit:     'Uredi',
        cancel:   'Prekliči',
        save:     'Shrani',
        delete:   'Izbriši',
        confirm:  'Potrdi',
        logout:   'Odjava',
        login:    'Prijava',
        settings: 'Nastavitve',
        language: 'Jezik',
        theme:    'Tema',
        actions:  'Dejanja',
        all:      'Vse',
    },
    todo: {
        todos:          'Opravila',
        title:          'Naziv',
        description:    'Opis',
        status:         'Status',
        due_at:         'Rok',
        add:            'Dodaj opravilo',
        edit:           'Uredi opravilo',
        complete:       'Zaključi',
        confirm_delete: 'Res želite izbrisati to opravilo?',
        no_todos:       'Ni opravil',
    },
    theme: {
        auto: 'Sistem',
        light: 'Svetla',
        dark: 'Temna',
    },
    status: {
        open:        'Odprto',
        in_progress: 'V delu',
        done:        'Zaključeno',
    },
    login: {
        username: 'Uporabniško ime',
        password: 'Geslo',
        failed:   'Napačno uporabniško ime ali geslo',
    },
    errors: {
        generic_error:    'Prišlo je do napake',
        invalid_data:     'Neveljavni podatki',
        not_found:        'Ni najdeno',
        unauthorized:     'Nimate dostopa',
        incorrect_status: 'Napačen status opravila',
        on_add:           'Napaka pri dodajanju',
        on_edit:          'Napaka pri urejanju',
        on_delete:        'Napaka pri brisanju',
    },
    success: {
        add:      'Uspešno dodano',
        edit:     'Uspešno posodobljeno',
        delete:   'Uspešno izbrisano',
        complete: 'Opravilo je zaključeno',
    },
    validation: {
        required:  'To polje je obvezno',
        max_length: 'Vrednost je predolga',
    },
}
